import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { AdminSurveyStats } from "@/types/survey";

interface SurveyStatsCardsProps {
  stats: AdminSurveyStats;
}

function formatPercent(count: number, total: number): string {
  if (total === 0) return "0%";
  return `${((count / total) * 100).toFixed(1)}%`;
}

export function SurveyStatsCards({ stats }: SurveyStatsCardsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            전체 유저
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {stats.totalUsers.toLocaleString()}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            설문 시작
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {stats.surveyStartedCount.toLocaleString()}
          </div>
          <p className="text-xs text-muted-foreground">
            {formatPercent(stats.surveyStartedCount, stats.totalUsers)}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            설문 완료
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {stats.surveyCompletedCount.toLocaleString()}
          </div>
          <p className="text-xs text-muted-foreground">
            {formatPercent(stats.surveyCompletedCount, stats.totalUsers)}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
